// extracted by mini-css-extract-plugin
export default {"loading":"LoadingScreen_loading__7LzYF","title":"LoadingScreen_title__47UOj","button":"LoadingScreen_button__nTX77"};